import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import img from '../../assets/imgs/Map-Megh.png'
import BasicTable from "../../components/basicTable/BasicTable";

export default function Block(){
    const {fontSize} = useTheme();
    return(
        <Box sx={{}}>
            <Typography variant="h1" sx={{fontSize:`${fontSize+0.5}rem`, margin:"5px 0"}}>Community & Rural Development Blocks in Meghalaya</Typography>
            <hr/>
            <Box sx={{padding: "2px 0 2px 10px", marginTop: "20px", width:"100%"}}>
                 <div style={{display:"flex", width:"100%", justifyContent:"center"}}>
                    <img src={img} alt="block map" style={{maxWidth:"100%"}}/>
                 </div>
                 <br/>
                 <div style={{display:"flex", justifyContent:"center", width:"100%"}}>

                <BasicTable heading={heading} data={data}/>
                 </div>
            </Box>
        </Box>
    )
}
const heading=[
    {
        data:"Serial Number",
        width:"15%"
    },
    {
        data:"District Name",
        width:"20%"
    },
    {
        data:"Serial Number",
        width:"15%"
    },
    {
        data:"Block Name",
        width:"30%"
    },
]

const data=[
    ["1","East Khasi Hills District","1","Mylliem C & RD Block"],
    ["","","2","Mawsynram C & RD Block"],
    ["","","3","Shella-Bholaganj C & RD Block"],
    ["","","4","Pynursla C & RD Block"],
    ["","","5","Mawryngkneng C & RD Block"],
    ["","","6","Mawphlang C & RD Block"],
    ["","","7","Mawkynrew C & RD Block"],
    ["","","8","Khatarshnong-Laitkroh C & RD Block"],
    ["","","9","Sohiong C & RD Block"],
    ["","","10","Mawpat C & RD Block"],
    ["","","11","Mawlai C & RD Block"],
    ["2","West Garo Hills District","12","Dalu C & RD Block"],
    ["","","13","Selsella C & RD Block"],
    ["","","14","Rongram C & RD Block"],
    ["","","15","Dadenggre C & RD Block"],
    ["","","16","Tikrikilla C & RD Block"],
    ["","","17","Gambegre C & RD Block"],
    ["","","18","Demdema C & RD Block"],
    ["","","19","Batabari C & RD Block"],
    ["3","West Khasi Hills District","20","Nongstoin C & RD Block"],
    ["","","21","Mawshynrut C & RD Block"],
    ["","","22","Rambrai C & RD Block"],
    ["","","23","Ri-Muliang C & RD Block"],
    ["","","24","Shallang C & RD Block"],
    ["4","East Garo Hills District","25","Dambo Rongjeng C & RD Block"],
    ["","","26","Songsak C & RD Block"],
    ["","","27","Samanda C & RD Block"],
    ["5","West Jaintia Hills District","28","Thadlaskein C & RD Block"],
    ["","","29","Laskein C & RD Block"],
    ["","","30","Amlarem C & RD Block"],
    ["","","31","Namdong C & RD Block"],
    ["6","South Garo Hills District","32","Baghmara C & RD Block"],
    ["","","33","Chokpot C & RD Block"],
    ["","","34","Ronggara C & RD Block"],
    ["","","35","Gasuapara C & RD Block"],
    ["","","36","Siju C & RD Block"],
    ["7","Ri Bhoi District","37","Umsning C & RD Block"],
    ["","","38","Umling C & RD Block"],
    ["","","39","Jirang C & RD Block"],
    ["","","40","Bhoirymbong C & RD Block"],
    ["8","North Garo Hills District","41","Resubelpara C & RD Block"],
    ["","","42","Kharkutta C & RD Block"],
    ["","","43","Bajengdoba C & RD Block"],
    ["","","44","Adokgre C & RD Block"],
    ["9","South West Garo Hills District","45","Betasing C & RD Block"],
    ["","","46","Zikzak C & RD Block"],
    ["","","47","Damalgre C & RD Block"],
    ["","","48","Purakhasia C & RD Block *"],
    ["10","East Jaintia Hills District","49","Wapung C & RD Block"],
    ["","","50","Saipung C & RD Block"],
    ["","","51","Lumshnong C & RD Block"],
    ["11","South West Khasi Hills District","52","Mawkyrwat C & RD Block"],
    ["","","53","Ranikor C & RD Block"],
    ["12","Eastern West Khasi Hills District","54","Mairang C & RD Block"],
    ["","","55","Mawthadraishan C & RD Block"],
]